/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForGenericTask extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForGenericTask");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForGenericTask.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForGenericTask>): BackgroundJobPayloadForGenericTask {
        let obj = Object.assign(new BackgroundJobPayloadForGenericTask(), model);
        BackgroundJobPayloadForGenericTask.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForGenericTask>): BackgroundJobPayloadForGenericTask {
        if (!model) return null;
        return BackgroundJobPayloadForGenericTask.newInstance(<BackgroundJobPayloadForGenericTask> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForGenericTask) {
        if (!obj) return;

        models.BackgroundJobPayloadForGenericTask.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForGenericTask): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForGenericTask.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    target: string;

    args: Array<string>;

}
